module.exports = __webpack_public_path__ + "img/local-8.0f51bce5.jpg";